export default {
  "_Margin": {
    "margin": 12,
    "@media (min-width:0px)": {
      "margin": 12
    },
    "@media (min-width:600px)": {
      "margin": 9
    },
    "@media (min-width:960px)": {
      "margin": 10.8
    },
    "@media (min-width:1280px)": {
      "margin": 12
    },
    "@media (min-width:1920px)": {
      "margin": 15
    }
  },
  "_MarginDouble": {
    "margin": 24,
    "@media (min-width:0px)": {
      "margin": 24
    },
    "@media (min-width:600px)": {
      "margin": 18
    },
    "@media (min-width:960px)": {
      "margin": 21.6
    },
    "@media (min-width:1280px)": {
      "margin": 24
    },
    "@media (min-width:1920px)": {
      "margin": 30
    }
  },
  "_MarginHalf": {
    "margin": 6,
    "@media (min-width:0px)": {
      "margin": 6
    },
    "@media (min-width:600px)": {
      "margin": 4.5
    },
    "@media (min-width:960px)": {
      "margin": 5.4
    },
    "@media (min-width:1280px)": {
      "margin": 6
    },
    "@media (min-width:1920px)": {
      "margin": 7.5
    }
  },
  "_MarginTop": {
    "marginTop": 12,
    "@media (min-width:0px)": {
      "marginTop": 12
    },
    "@media (min-width:600px)": {
      "marginTop": 9
    },
    "@media (min-width:960px)": {
      "marginTop": 10.8
    },
    "@media (min-width:1280px)": {
      "marginTop": 12
    },
    "@media (min-width:1920px)": {
      "marginTop": 15
    }
  },
  "_MarginTopHalf": {
    "marginTop": 6,
    "@media (min-width:0px)": {
      "marginTop": 6
    },
    "@media (min-width:600px)": {
      "marginTop": 4.5
    },
    "@media (min-width:960px)": {
      "marginTop": 5.4
    },
    "@media (min-width:1280px)": {
      "marginTop": 6
    },
    "@media (min-width:1920px)": {
      "marginTop": 7.5
    }
  },
  "_MarginTopDouble": {
    "marginTop": 24,
    "@media (min-width:0px)": {
      "marginTop": 24
    },
    "@media (min-width:600px)": {
      "marginTop": 18
    },
    "@media (min-width:960px)": {
      "marginTop": 21.6
    },
    "@media (min-width:1280px)": {
      "marginTop": 24
    },
    "@media (min-width:1920px)": {
      "marginTop": 30
    }
  },
  "_MarginBottom": {
    "marginBottom": 12,
    "@media (min-width:0px)": {
      "marginBottom": 12
    },
    "@media (min-width:600px)": {
      "marginBottom": 9
    },
    "@media (min-width:960px)": {
      "marginBottom": 10.8
    },
    "@media (min-width:1280px)": {
      "marginBottom": 12
    },
    "@media (min-width:1920px)": {
      "marginBottom": 15
    }
  },
  "_MarginBottomHalf": {
    "marginBottom": 6,
    "@media (min-width:0px)": {
      "marginBottom": 6
    },
    "@media (min-width:600px)": {
      "marginBottom": 4.5
    },
    "@media (min-width:960px)": {
      "marginBottom": 5.4
    },
    "@media (min-width:1280px)": {
      "marginBottom": 6
    },
    "@media (min-width:1920px)": {
      "marginBottom": 7.5
    }
  },
  "_MarginBottomDouble": {
    "marginBottom": 24,
    "@media (min-width:0px)": {
      "marginBottom": 24
    },
    "@media (min-width:600px)": {
      "marginBottom": 18
    },
    "@media (min-width:960px)": {
      "marginBottom": 21.6
    },
    "@media (min-width:1280px)": {
      "marginBottom": 24
    },
    "@media (min-width:1920px)": {
      "marginBottom": 30
    }
  },
  "_MarginVertical": {
    "marginTop": 12,
    "@media (min-width:0px)": {
      "marginBottom": 12
    },
    "@media (min-width:600px)": {
      "marginBottom": 9
    },
    "@media (min-width:960px)": {
      "marginBottom": 10.8
    },
    "@media (min-width:1280px)": {
      "marginBottom": 12
    },
    "@media (min-width:1920px)": {
      "marginBottom": 15
    },
    "marginBottom": 12
  },
  "_MarginVerticalHalf": {
    "marginTop": 6,
    "@media (min-width:0px)": {
      "marginBottom": 6
    },
    "@media (min-width:600px)": {
      "marginBottom": 4.5
    },
    "@media (min-width:960px)": {
      "marginBottom": 5.4
    },
    "@media (min-width:1280px)": {
      "marginBottom": 6
    },
    "@media (min-width:1920px)": {
      "marginBottom": 7.5
    },
    "marginBottom": 6
  },
  "_MarginVerticalDouble": {
    "marginTop": 24,
    "@media (min-width:0px)": {
      "marginBottom": 24
    },
    "@media (min-width:600px)": {
      "marginBottom": 18
    },
    "@media (min-width:960px)": {
      "marginBottom": 21.6
    },
    "@media (min-width:1280px)": {
      "marginBottom": 24
    },
    "@media (min-width:1920px)": {
      "marginBottom": 30
    },
    "marginBottom": 24
  },
  "_MarginLeft": {
    "marginLeft": 12,
    "@media (min-width:0px)": {
      "marginLeft": 12
    },
    "@media (min-width:600px)": {
      "marginLeft": 9
    },
    "@media (min-width:960px)": {
      "marginLeft": 10.8
    },
    "@media (min-width:1280px)": {
      "marginLeft": 12
    },
    "@media (min-width:1920px)": {
      "marginLeft": 15
    }
  },
  "_MarginLeftHalf": {
    "marginLeft": 6,
    "@media (min-width:0px)": {
      "marginLeft": 6
    },
    "@media (min-width:600px)": {
      "marginLeft": 4.5
    },
    "@media (min-width:960px)": {
      "marginLeft": 5.4
    },
    "@media (min-width:1280px)": {
      "marginLeft": 6
    },
    "@media (min-width:1920px)": {
      "marginLeft": 7.5
    }
  },
  "_MarginLeftDouble": {
    "marginLeft": 24,
    "@media (min-width:0px)": {
      "marginLeft": 24
    },
    "@media (min-width:600px)": {
      "marginLeft": 18
    },
    "@media (min-width:960px)": {
      "marginLeft": 21.6
    },
    "@media (min-width:1280px)": {
      "marginLeft": 24
    },
    "@media (min-width:1920px)": {
      "marginLeft": 30
    }
  },
  "_MarginRight": {
    "marginRight": 12,
    "@media (min-width:0px)": {
      "marginRight": 12
    },
    "@media (min-width:600px)": {
      "marginRight": 9
    },
    "@media (min-width:960px)": {
      "marginRight": 10.8
    },
    "@media (min-width:1280px)": {
      "marginRight": 12
    },
    "@media (min-width:1920px)": {
      "marginRight": 15
    }
  },
  "_MarginRightHalf": {
    "marginRight": 6,
    "@media (min-width:0px)": {
      "marginRight": 6
    },
    "@media (min-width:600px)": {
      "marginRight": 4.5
    },
    "@media (min-width:960px)": {
      "marginRight": 5.4
    },
    "@media (min-width:1280px)": {
      "marginRight": 6
    },
    "@media (min-width:1920px)": {
      "marginRight": 7.5
    }
  },
  "_MarginRightDouble": {
    "marginRight": 24,
    "@media (min-width:0px)": {
      "marginRight": 24
    },
    "@media (min-width:600px)": {
      "marginRight": 18
    },
    "@media (min-width:960px)": {
      "marginRight": 21.6
    },
    "@media (min-width:1280px)": {
      "marginRight": 24
    },
    "@media (min-width:1920px)": {
      "marginRight": 30
    }
  },
  "_MarginHorizontal": {
    "marginLeft": 12,
    "@media (min-width:0px)": {
      "marginRight": 12
    },
    "@media (min-width:600px)": {
      "marginRight": 9
    },
    "@media (min-width:960px)": {
      "marginRight": 10.8
    },
    "@media (min-width:1280px)": {
      "marginRight": 12
    },
    "@media (min-width:1920px)": {
      "marginRight": 15
    },
    "marginRight": 12
  },
  "_MarginHorizontalHalf": {
    "marginLeft": 6,
    "@media (min-width:0px)": {
      "marginRight": 6
    },
    "@media (min-width:600px)": {
      "marginRight": 4.5
    },
    "@media (min-width:960px)": {
      "marginRight": 5.4
    },
    "@media (min-width:1280px)": {
      "marginRight": 6
    },
    "@media (min-width:1920px)": {
      "marginRight": 7.5
    },
    "marginRight": 6
  },
  "_MarginHorizontalDouble": {
    "marginLeft": 24,
    "@media (min-width:0px)": {
      "marginRight": 24
    },
    "@media (min-width:600px)": {
      "marginRight": 18
    },
    "@media (min-width:960px)": {
      "marginRight": 21.6
    },
    "@media (min-width:1280px)": {
      "marginRight": 24
    },
    "@media (min-width:1920px)": {
      "marginRight": 30
    },
    "marginRight": 24
  },
  "_Padding": {
    "padding": 12,
    "@media (min-width:0px)": {
      "padding": 12
    },
    "@media (min-width:600px)": {
      "padding": 9
    },
    "@media (min-width:960px)": {
      "padding": 10.8
    },
    "@media (min-width:1280px)": {
      "padding": 12
    },
    "@media (min-width:1920px)": {
      "padding": 15
    }
  },
  "_PaddingDouble": {
    "padding": 24,
    "@media (min-width:0px)": {
      "padding": 24
    },
    "@media (min-width:600px)": {
      "padding": 18
    },
    "@media (min-width:960px)": {
      "padding": 21.6
    },
    "@media (min-width:1280px)": {
      "padding": 24
    },
    "@media (min-width:1920px)": {
      "padding": 30
    }
  },
  "_PaddingHalf": {
    "padding": 6,
    "@media (min-width:0px)": {
      "padding": 6
    },
    "@media (min-width:600px)": {
      "padding": 4.5
    },
    "@media (min-width:960px)": {
      "padding": 5.4
    },
    "@media (min-width:1280px)": {
      "padding": 6
    },
    "@media (min-width:1920px)": {
      "padding": 7.5
    }
  },
  "_Padding0": {
    "padding": 0
  },
  "_PaddingTop": {
    "paddingTop": 12,
    "@media (min-width:0px)": {
      "paddingTop": 12
    },
    "@media (min-width:600px)": {
      "paddingTop": 9
    },
    "@media (min-width:960px)": {
      "paddingTop": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingTop": 12
    },
    "@media (min-width:1920px)": {
      "paddingTop": 15
    }
  },
  "_PaddingTopHalf": {
    "paddingTop": 6,
    "@media (min-width:0px)": {
      "paddingTop": 6
    },
    "@media (min-width:600px)": {
      "paddingTop": 4.5
    },
    "@media (min-width:960px)": {
      "paddingTop": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingTop": 6
    },
    "@media (min-width:1920px)": {
      "paddingTop": 7.5
    }
  },
  "_PaddingTopDouble": {
    "paddingTop": 24,
    "@media (min-width:0px)": {
      "paddingTop": 24
    },
    "@media (min-width:600px)": {
      "paddingTop": 18
    },
    "@media (min-width:960px)": {
      "paddingTop": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingTop": 24
    },
    "@media (min-width:1920px)": {
      "paddingTop": 30
    }
  },
  "_PaddingBottom": {
    "paddingBottom": 12,
    "@media (min-width:0px)": {
      "paddingBottom": 12
    },
    "@media (min-width:600px)": {
      "paddingBottom": 9
    },
    "@media (min-width:960px)": {
      "paddingBottom": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 12
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 15
    }
  },
  "_PaddingBottomHalf": {
    "paddingBottom": 6,
    "@media (min-width:0px)": {
      "paddingBottom": 6
    },
    "@media (min-width:600px)": {
      "paddingBottom": 4.5
    },
    "@media (min-width:960px)": {
      "paddingBottom": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 6
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 7.5
    }
  },
  "_PaddingBottomDouble": {
    "paddingBottom": 24,
    "@media (min-width:0px)": {
      "paddingBottom": 24
    },
    "@media (min-width:600px)": {
      "paddingBottom": 18
    },
    "@media (min-width:960px)": {
      "paddingBottom": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 24
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 30
    }
  },
  "_PaddingVertical": {
    "paddingTop": 12,
    "@media (min-width:0px)": {
      "paddingBottom": 12
    },
    "@media (min-width:600px)": {
      "paddingBottom": 9
    },
    "@media (min-width:960px)": {
      "paddingBottom": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 12
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 15
    },
    "paddingBottom": 12
  },
  "_PaddingVerticalHalf": {
    "paddingTop": 6,
    "@media (min-width:0px)": {
      "paddingBottom": 6
    },
    "@media (min-width:600px)": {
      "paddingBottom": 4.5
    },
    "@media (min-width:960px)": {
      "paddingBottom": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 6
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 7.5
    },
    "paddingBottom": 6
  },
  "_PaddingVerticalDouble": {
    "paddingTop": 24,
    "@media (min-width:0px)": {
      "paddingBottom": 24
    },
    "@media (min-width:600px)": {
      "paddingBottom": 18
    },
    "@media (min-width:960px)": {
      "paddingBottom": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingBottom": 24
    },
    "@media (min-width:1920px)": {
      "paddingBottom": 30
    },
    "paddingBottom": 24
  },
  "_PaddingLeft": {
    "paddingLeft": 12,
    "@media (min-width:0px)": {
      "paddingLeft": 12
    },
    "@media (min-width:600px)": {
      "paddingLeft": 9
    },
    "@media (min-width:960px)": {
      "paddingLeft": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingLeft": 12
    },
    "@media (min-width:1920px)": {
      "paddingLeft": 15
    }
  },
  "_PaddingLeftHalf": {
    "paddingLeft": 6,
    "@media (min-width:0px)": {
      "paddingLeft": 6
    },
    "@media (min-width:600px)": {
      "paddingLeft": 4.5
    },
    "@media (min-width:960px)": {
      "paddingLeft": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingLeft": 6
    },
    "@media (min-width:1920px)": {
      "paddingLeft": 7.5
    }
  },
  "_PaddingLeftDouble": {
    "paddingLeft": 24,
    "@media (min-width:0px)": {
      "paddingLeft": 24
    },
    "@media (min-width:600px)": {
      "paddingLeft": 18
    },
    "@media (min-width:960px)": {
      "paddingLeft": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingLeft": 24
    },
    "@media (min-width:1920px)": {
      "paddingLeft": 30
    }
  },
  "_PaddingRight": {
    "paddingRight": 12,
    "@media (min-width:0px)": {
      "paddingRight": 12
    },
    "@media (min-width:600px)": {
      "paddingRight": 9
    },
    "@media (min-width:960px)": {
      "paddingRight": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingRight": 12
    },
    "@media (min-width:1920px)": {
      "paddingRight": 15
    }
  },
  "_PaddingRightHalf": {
    "paddingRight": 6,
    "@media (min-width:0px)": {
      "paddingRight": 6
    },
    "@media (min-width:600px)": {
      "paddingRight": 4.5
    },
    "@media (min-width:960px)": {
      "paddingRight": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingRight": 6
    },
    "@media (min-width:1920px)": {
      "paddingRight": 7.5
    }
  },
  "_PaddingRightDouble": {
    "paddingRight": 24,
    "@media (min-width:0px)": {
      "paddingRight": 24
    },
    "@media (min-width:600px)": {
      "paddingRight": 18
    },
    "@media (min-width:960px)": {
      "paddingRight": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingRight": 24
    },
    "@media (min-width:1920px)": {
      "paddingRight": 30
    }
  },
  "_PaddingHorizontal": {
    "paddingLeft": 12,
    "@media (min-width:0px)": {
      "paddingRight": 12
    },
    "@media (min-width:600px)": {
      "paddingRight": 9
    },
    "@media (min-width:960px)": {
      "paddingRight": 10.8
    },
    "@media (min-width:1280px)": {
      "paddingRight": 12
    },
    "@media (min-width:1920px)": {
      "paddingRight": 15
    },
    "paddingRight": 12
  },
  "_PaddingHorizontalHalf": {
    "paddingLeft": 6,
    "@media (min-width:0px)": {
      "paddingRight": 6
    },
    "@media (min-width:600px)": {
      "paddingRight": 4.5
    },
    "@media (min-width:960px)": {
      "paddingRight": 5.4
    },
    "@media (min-width:1280px)": {
      "paddingRight": 6
    },
    "@media (min-width:1920px)": {
      "paddingRight": 7.5
    },
    "paddingRight": 6
  },
  "_PaddingHorizontalDouble": {
    "paddingLeft": 24,
    "@media (min-width:0px)": {
      "paddingRight": 24
    },
    "@media (min-width:600px)": {
      "paddingRight": 18
    },
    "@media (min-width:960px)": {
      "paddingRight": 21.6
    },
    "@media (min-width:1280px)": {
      "paddingRight": 24
    },
    "@media (min-width:1920px)": {
      "paddingRight": 30
    },
    "paddingRight": 24
  },
  "_BackgroundColorInfo": {
    "backgroundColor": "#2196f3",
    "color": "#fff"
  },
  "_BackgroundColorWarning": {
    "backgroundColor": "#ff9800",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundColorError": {
    "backgroundColor": "#f44336",
    "color": "#fff"
  },
  "_BackgroundColorSuccess": {
    "backgroundColor": "#4caf50",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundColorPrimary": {
    "backgroundColor": "#333A4A",
    "color": "#fff"
  },
  "_BackgroundColorSecondary": {
    "backgroundColor": "#F78E1E",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundColorDivider": {
    "backgroundColor": "#e0e0e0"
  },
  "_BackgroundColorPaper": {
    "backgroundColor": "#FFFFFF",
    "color": "#343A49"
  },
  "_BackgroundColorDefault": {
    "backgroundColor": "#FAFAFA"
  },
  "_BackgroundTransparent": {
    "background": "transparent"
  },
  "_BackgroundGradientPrimary": {
    "backgroundImage": "linear-gradient(45deg, #333A4A 0%, #343A49 100%)",
    "color": "#fff"
  },
  "_BackgroundGradientSecondary": {
    "backgroundImage": "linear-gradient(45deg, #F78E1E 0%, #EE3124 100%)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundGradientTertiary": {
    "backgroundImage": "linear-gradient(45deg, #F78E1E 0%, #F9D147 100%)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundGradientDefault": {
    "backgroundImage": "linear-gradient(45deg, rgb(35, 40, 51) 0%, rgb(91, 97, 110) 100%)",
    "color": "#fff"
  },
  "_BackgroundGradientInfo": {
    "backgroundImage": "linear-gradient(45deg, rgb(23, 105, 170) 0%, rgb(77, 171, 245) 100%)",
    "color": "#fff"
  },
  "_BackgroundGradientWarning": {
    "backgroundImage": "linear-gradient(45deg, rgb(178, 106, 0) 0%, rgb(255, 172, 51) 100%)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_BackgroundGradientError": {
    "backgroundImage": "linear-gradient(45deg, rgb(170, 46, 37) 0%, rgb(246, 104, 94) 100%)",
    "color": "#fff"
  },
  "_BackgroundGradientDivider": {
    "backgroundImage": "linear-gradient(45deg, #e0e0e0 0%, #fff 100%)"
  },
  "_FontColorInfo": {
    "color": "#2196f3"
  },
  "_FontColorWarning": {
    "color": "#ff9800"
  },
  "_FontColorError": {
    "color": "#f44336"
  },
  "_FontColorSuccess": {
    "color": "#4caf50"
  },
  "_FontColorPrimary": {
    "color": "#333A4A"
  },
  "_FontColorSecondary": {
    "color": "#F78E1E"
  },
  "_FontColorHint": {
    "color": "rgba(0, 0, 0, 0.38)"
  },
  "_FontColorInherit": {
    "color": "inherit"
  },
  "_TextAlignLeft": {
    "textAlign": "left"
  },
  "_TextAlignRight": {
    "textAlign": "right"
  },
  "_TextAlignCenter": {
    "textAlign": "center"
  },
  "_FontLight": {
    "color": "#fff"
  },
  "_FontDark": {
    "color": "#000"
  },
  "_FontSizeBody1": {
    "fontSize": 14,
    "@media (min-width:0px)": {
      "fontSize": 14
    },
    "@media (min-width:600px)": {
      "fontSize": 10.5
    },
    "@media (min-width:960px)": {
      "fontSize": 12.6
    },
    "@media (min-width:1280px)": {
      "fontSize": 14
    },
    "@media (min-width:1920px)": {
      "fontSize": 17.5
    }
  },
  "_FontSizeBody2": {
    "fontSize": 10,
    "@media (min-width:0px)": {
      "fontSize": 10
    },
    "@media (min-width:600px)": {
      "fontSize": 7.5
    },
    "@media (min-width:960px)": {
      "fontSize": 9
    },
    "@media (min-width:1280px)": {
      "fontSize": 10
    },
    "@media (min-width:1920px)": {
      "fontSize": 12.5
    }
  },
  "_ShadowNone": {
    "boxShadow": "none"
  },
  "_Shadow1": {
    "boxShadow": "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow2": {
    "boxShadow": "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow3": {
    "boxShadow": "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow4": {
    "boxShadow": "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow5": {
    "boxShadow": "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow6": {
    "boxShadow": "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  "_Shadow7": {
    "boxShadow": "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)"
  },
  "_Shadow8": {
    "boxShadow": "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)"
  },
  "_Shadow9": {
    "boxShadow": "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)"
  },
  "_Shadow10": {
    "boxShadow": "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)"
  },
  "_Shadow11": {
    "boxShadow": "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)"
  },
  "_Shadow12": {
    "boxShadow": "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)"
  },
  "_Shadow13": {
    "boxShadow": "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)"
  },
  "_Shadow14": {
    "boxShadow": "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)"
  },
  "_Shadow15": {
    "boxShadow": "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)"
  },
  "_Shadow16": {
    "boxShadow": "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)"
  },
  "_BorderRadius": {
    "borderRadius": 4,
    "@media (min-width:0px)": {
      "borderRadius": 4
    },
    "@media (min-width:600px)": {
      "borderRadius": 3
    },
    "@media (min-width:960px)": {
      "borderRadius": 3.6
    },
    "@media (min-width:1280px)": {
      "borderRadius": 4
    },
    "@media (min-width:1920px)": {
      "borderRadius": 5
    }
  },
  "_BorderRadiusHalf": {
    "borderRadius": 2,
    "@media (min-width:0px)": {
      "borderRadius": 2
    },
    "@media (min-width:600px)": {
      "borderRadius": 1.5
    },
    "@media (min-width:960px)": {
      "borderRadius": 1.8
    },
    "@media (min-width:1280px)": {
      "borderRadius": 2
    },
    "@media (min-width:1920px)": {
      "borderRadius": 2.5
    }
  },
  "_BorderRadiusDouble": {
    "borderRadius": 8,
    "@media (min-width:0px)": {
      "borderRadius": 8
    },
    "@media (min-width:600px)": {
      "borderRadius": 6
    },
    "@media (min-width:960px)": {
      "borderRadius": 7.2
    },
    "@media (min-width:1280px)": {
      "borderRadius": 8
    },
    "@media (min-width:1920px)": {
      "borderRadius": 10
    }
  },
  "_Width100Percent": {
    "width": "100%"
  },
  "_Width100ViewportWidth": {
    "width": "100vw"
  },
  "_Height100Percent": {
    "height": "100%"
  },
  "_Height100ViewportHeight": {
    "height": "100vh"
  },
  "_ChipSizeExtraSmall": {
    "height": "unset",
    "& span[class^='MuiChip-label'], & span[class*=' MuiChip-label']": {
      "fontFamily": "Helvetica",
      "fontWeight": 400,
      "fontSize": 10,
      "lineHeight": 1.43,
      "paddingTop": 3,
      "paddingBottom": 3,
      "paddingLeft": 6,
      "paddingRight": 6
    },
    "& svg[class^='MuiChip-deleteIcon'], & svg[class*=' MuiChip-deleteIcon']": {
      "margin": 0
    }
  },
  "_Flex": {
    "display": "flex"
  },
  "_FlexGrow0": {
    "flexGrow": 0
  },
  "_FlexGrow1": {
    "flexGrow": 1
  },
  "_FlexShrink0": {
    "flexShrink": 0
  },
  "_AlignItemsCenter": {
    "alignItems": "center"
  },
  "_AlignItemsFlexStart": {
    "alignItems": "flex-start"
  },
  "_AlignItemsFlexEnd": {
    "alignItems": "flex-end"
  },
  "_AlignItemsStretch": {
    "alignItems": "stretch"
  },
  "_JustifyContentCenter": {
    "justifyContent": "center"
  },
  "_JustifyContentFlexStart": {
    "justifyContent": "flex-start"
  },
  "_JustifyContentFlexEnd": {
    "justifyContent": "flex-end"
  },
  "_FlexDirectionColumn": {
    "flexDirection": "column"
  },
  "_FlexDirectionRow": {
    "flexDirection": "row"
  },
  "_FlexDirectionColumnReverse": {
    "flexDirection": "column-reverse"
  },
  "_FlexBasis50Percent": {
    "flexBasis": "50%"
  },
  "_Root": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "position": "fixed",
    "width": "100vw",
    "left": 0,
    "top": 0,
    "height": "100vh",
    "minHeight": 400,
    "minWidth": 320,
    "boxSizing": "border-box"
  },
  "_RootMobile": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "minHeight": 400,
    "minWidth": 320,
    "boxSizing": "border-box"
  },
  "_ActivityBackground": {
    "boxSizing": "border-box",
    "overflow": "auto",
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "display": "flex",
    "flexDirection": "column",
    "flexGrow": 1,
    "justifyContent": "center",
    "backgroundImage": "linear-gradient(45deg, rgb(35, 40, 51) 0%, rgb(91, 97, 110) 100%)",
    "color": "#fff"
  },
  "_ActivityContainer": {
    "overflow": "auto",
    "display": "flex"
  },
  "_ActivityPaperWidth25": {
    "flexBasis": "25%"
  },
  "_ActivityPaperWidth50": {
    "flexBasis": "50%"
  },
  "_ActivityPaperWidth75": {
    "flexBasis": "75%"
  },
  "_ActivityPaperWidth100": {
    "flexBasis": "100%"
  },
  "_ActivityPaper": {
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "column"
  },
  "_ActivityHeader": {},
  "_ActivityFooter": {},
  "_ActivityPaperTransparent": {
    "color": "#FFFFFF",
    "& .MuiDivider-root": {
      "backgroundColor": "#FAFAFA"
    },
    "overflow": "hidden",
    "background": "transparent",
    "boxShadow": "none"
  },
  "_PaperTransparent": {},
  "_FullHeightGridContainer": {
    "minHeight": 0,
    "flex": 1,
    "display": "flex",
    "flexGrow": 1
  },
  "_ScrollableGridItem": {
    "overflow": "auto",
    "height": "100%",
    "flexGrow": 1
  },
  "_ButtonTextAlignLeft": {
    "justifyContent": "flex-start"
  },
  "_ButtonTextAlignRight": {
    "justifyContent": "flex-end"
  },
  "_PositionSticky": {
    "position": "sticky"
  },
  "_PositionStickyTop": {
    "position": "sticky",
    "top": 0
  },
  "_PositionStickyBottom": {
    "position": "sticky",
    "bottom": 0
  },
  "_OverflowScroll": {
    "overflow": "auto"
  },
  "_OverflowAuto": {
    "overflow": "auto"
  },
  "_OverflowHidden": {
    "overflow": "hidden"
  },
  "_TaskCardPrimary": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#333A4A"
  },
  "_TaskCardSecondary": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#F78E1E"
  },
  "_TaskCardPositive": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#4caf50"
  },
  "_TaskCardNegative": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#f44336"
  },
  "_TaskCardWarning": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#ff9800"
  },
  "_TaskCardPrimarySolid": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#333A4A",
    "background": "rgb(91, 97, 110)",
    "color": "#fff"
  },
  "_TaskCardSecondarySolid": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#F78E1E",
    "background": "rgb(248, 164, 75)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_TaskCardPositiveSolid": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#4caf50",
    "background": "rgb(111, 191, 115)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_TaskCardNegativeSolid": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#f44336",
    "background": "rgb(246, 104, 94)",
    "color": "#fff"
  },
  "_TaskCardWarningSolid": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "#ff9800",
    "background": "rgb(255, 172, 51)",
    "color": "rgba(0, 0, 0, 0.87)"
  },
  "_TaskCardDisabled": {
    "borderLeftWidth": 6,
    "@media (min-width:0px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:600px)": {
      "borderLeftWidth": 4.5
    },
    "@media (min-width:960px)": {
      "borderLeftWidth": 5.4
    },
    "@media (min-width:1280px)": {
      "borderLeftWidth": 6
    },
    "@media (min-width:1920px)": {
      "borderLeftWidth": 7.5
    },
    "borderLeftStyle": "solid",
    "borderColor": "rgb(91, 97, 110)",
    "background": "#e0e0e0"
  },
  "_LinearProgressColorSuccess": {
    "backgroundColor": "#e0e0e0",
    "& div[class^='MuiLinearProgress-bar'], & div[class*=' MuiLinearProgress-bar']": {
      "backgroundImage": "linear-gradient(90deg, rgb(111, 191, 115), rgb(53, 122, 56))"
    }
  },
  "_LinearProgressColorError": {
    "backgroundColor": "#e0e0e0",
    "& div[class^='MuiLinearProgress-bar'], & div[class*=' MuiLinearProgress-bar']": {
      "backgroundImage": "linear-gradient(90deg, rgb(246, 104, 94), rgb(170, 46, 37))"
    }
  },
  "_CircularProgressColorSuccess": {
    "& [class^='MuiCircularProgress-circle'], & [class*=' MuiCircularProgress-circle']": {
      "stroke": "#4caf50"
    }
  },
  "_CircularProgressColorError": {
    "& [class^='MuiCircularProgress-circle'], & [class*=' MuiCircularProgress-circle']": {
      "stroke": "#f44336"
    }
  },
  "_CircularProgressColorDivider": {
    "& [class^='MuiCircularProgress-circle'], & [class*=' MuiCircularProgress-circle']": {
      "stroke": "#e0e0e0"
    }
  },
  "_AllAddOnsBox": {},
  "_IndividualAddOnBox": {},
  "_ActivityContainerAdaptiveHeight": {
    "flexGrow": 0
  },
  "_ActivityContainerFullHeight": {
    "flexGrow": 1
  }
}